<template>
  <div id="login">
    <div class="container-fluid h-100">
      <div class="h-100 d-flex flex-column justify-content-between align-items-stretch">
        <div class="row">
          <div class="col-12 p-3 d-flex justify-content-center align-content-center">
            <img src="@/assets/img/logo.svg" class="img-fluid" alt="logo" width="280" />
          </div>
        </div>
        <div class="row" v-if="asLogin" key="login">
          <div class="col form_padrao shadow-sm" v-if="!loadingToken">
            <h5 class="pb-4 text-uppercase text-center">Acesse sua conta</h5>
            <form action @submit.prevent="login">
              <div class="form-group flutuante">
                <input type="text" name="email" id="email" required v-model="userData.userName" />
                <label for="email">Usuário / CPF OU CNPJ</label>
              </div>
              <div class="form-group flutuante position-relative">
                <i class="material-icons visibility" :class="visibility" @click="switchPassword"
                  alt="Visualizar senha">{{ visibility }}</i>
                <input :type="textType" name="senha" id="senha" required v-model="userData.password" />
                <label for="senha">Senha</label>
              </div>
              <div class="form-group">
                <div class="alert alert-danger border-0 text-center" v-if="error" role="alert">
                  {{
                    errorMsg == 401
                      ? "Usuário ou senha inválidos"
                      : "falha ao autenticar"
                  }}
                </div>
              </div>
              <div class="row">
                <div class="col-md-7 col-6 align-self-center font-13">
                  <a href="javascript:void(0)" @click="asLogin = false" class="esqueci">Esqueci minha senha</a>
                </div>
                <div class="col-md-5 col-6">
                  <button type="submit" class="btn btn-verde p-0" :disabled="loading">
                    <span class="spinner-grow spinner-grow-sm pr-2" role="status" aria-hidden="true"
                      v-show="loading"></span>
                    <span v-if="loading">Aguarde</span>
                    <span v-else>Entrar</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div class="col form_padrao shadow-sm p-5" v-else>
            <loading style="margin-top: 20px" />
            <h1 class="text-center pt-5">
              Entrando... Por favor aguarde um momento
            </h1>
          </div>
        </div>
        <div class="row" v-else key="esqueci">
          <div class="col form_padrao shadow-sm">
            <h5 class="pb-4 text-uppercase text-center">Esqueci minha senha</h5>
            <form action @submit.prevent="recuperarSenha">
              <div class="form-group flutuante">
                <input type="text" name="usuario" id="usuario" required v-model="userData.userName" v-mask="[
                  '### ### ##',
                  '###.###.###-##',
                  '##.###.###/####-##',
                ]" />
                <label for="usuario">Usuário / CPF ou CNPJ</label>
              </div>
              <div class="form-group flutuante">
                <input type="text" name="email" id="email" required v-model="userData.email" />
                <label for="email">E-mail</label>
              </div>
              <div class="text-danger mt-2 mb-2 font-13" v-if="emailPrincipal">
                Informe o e-mail da sua conta principal: {{ emailPrincipal }}
              </div>
              <div class="row">
                <div class="col-md-7 col-6 align-self-center font-13">
                  <a href="javascript:void(0)" @click="asLogin = true" class="esqueci d-flex align-items-center">
                    <i class="material-icons pr-1">arrow_left</i> Voltar para
                    login
                  </a>
                </div>
                <div class="col-md-5 col-6">
                  <button type="submit" class="btn btn-verde p-0" :disabled="loading">
                    <span class="spinner-grow spinner-grow-sm pr-2" role="status" aria-hidden="true"
                      v-show="loading"></span>
                    <span v-if="loading">Aguarde</span>
                    <span v-else>Enviar</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="row">
          <div class="col-12 p-3 d-flex justify-content-center align-content-end termos">
            <!-- <div>
              <a href="#">Política de Privacidade</a> e <a href="#">Termos de Uso</a>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
export default {
  name: "Login",
  components: {},
  data() {
    return {
      visibility: "visibility",
      textType: "password",
      asLogin: true,
      userData: {
        userName: "",
        password: "",
        email: "",
      },
      loading: false,
      loadingToken: false,
      error: false,
      errorMsg: "",
      exibeEmail: true,
      emailPrincipal: null,
    };
  },
  methods: {
    switchPassword() {
      this.textType = this.textType == "password" ? "text" : "password";
      this.visibility =
        this.visibility == "visibility" ? "visibility_off" : "visibility";
    },
    recuperarSenha() {
      this.loading = true;
      this.error = false;
      this.$http
        .post("/Login/RecuperaLoginPorEmail", {
          email: this.userData.email.trim().replace(/\s/g, ""),
          codsocio: this.userData.userName.trim().replace(/\D/g, ""),
        })
        .then(() => {
          this.$toast.open({
            message: "Solicitação enviada ! Verifique sua caixa de e-mail.",
            type: "success",
            duration: 4000,
          });
          this.loading = false;
          this.asLogin = true;
          this.userData = {};
        })
        .catch((error) => {
          if (error.response.data.email) {
            this.emailPrincipal = error.response.data.email;
          }
          this.$toast.open({
            message:
              "Cadastro não encontrado, informe ao suporte o problema apresentado!" +
              error.response.data.email,
            type: "error",
          });
          this.loading = false;
          this.error = true;
        });
    },
    login() {
      this.loading = true;
      this.error = false;
      let user = this.userData.userName.replace(/ /g, "");
      this.userData["userName"] = user;
      this.$http
        .login({ userName: user, password: this.userData.password })
        .then((resp) => {
          if (!resp.data.token) {
            throw new Error("Error login.");
          }
          window.sessionStorage.token = `Bearer ${resp.data.token}`;
          window.sessionStorage.userData = JSON.stringify(resp.data);
          window.sessionStorage.removeItem(
            "assistenciaFuneralModalVerificado"
          );
          window.sessionStorage.setItem(
            "exibirAssistenciaFuneralAposLogin",
            "true"
          );

          this.$store.commit("UPDATE_USER", resp.data);
        })
        .then(() => {
          Vue.prototype.$user = JSON.parse(sessionStorage.userData);
          this.loading = false;
          this.$router.push({ name: "Dashboard" });
        })
        .catch((error) => {
          this.$toast.open({
            message: "Login ou senha inválidos, tente novamente",
            type: "error",
          });
          this.loading = false;
          this.error = true;
          this.errorMsg = error.response.status ?? "";
        });
    },
    loginPortal() {
      this.loadingToken = true;
      this.loading = true;
      this.error = false;
      axios.defaults.headers.common = {
        Authorization: `bearer ${this.$route.query.token}`,
      };
      axios
        .get(process.env.VUE_APP_URL + "/login/me")
        .then((resp) => {
          window.sessionStorage.token = `Bearer ${this.$route.query.token}`;
          window.sessionStorage.userData = JSON.stringify(resp.data);
          window.sessionStorage.removeItem(
            "assistenciaFuneralModalVerificado"
          );
          window.sessionStorage.setItem(
            "exibirAssistenciaFuneralAposLogin",
            "true"
          );
          this.$store.commit("UPDATE_USER", resp.data);
          this.loadingToken = false;
        })
        .then(() => {
          Vue.prototype.$user = JSON.parse(sessionStorage.userData);
          this.loading = false;
          this.$router.push({ name: "Dashboard" });
        })
        .catch((error) => {
          this.loadingToken = false;
          this.$toast.open({
            message: "Token de acesso inválido.",
            type: "error",
          });
          this.loading = false;
          this.error = true;
          this.errorMsg = error.response.status;
        });
    },
  },
  computed: {
    params() {
      return this.$route.params;
    },
  },
  created() {
    if (this.$route.query.token) {
      this.loginPortal();
    }
    document.title = "CDL/BH - Área do Associado";
    window.addEventListener("offline", () => {
      this.$toast.open({
        message: "Sem conexão com a internet.",
        type: "error",
        duration: 3000,
      });
    });

    if (this.params.recuperarSenha === "esqueci-minha-senha") {
      this.asLogin = false;
    }
  },
};

</script>

<style lang="scss" scoped>

#login {
    background: #05428E;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    height: 100vh;
    padding: 1rem;
}

.visibility {
  position: absolute;
  right: 10px;
  top: 20px;
  font-size: 1rem;
  cursor: pointer;
}
</style>
